module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "a-midsummer-nights-dream"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "150px",
      "text-align": "center"
    }
  }, [_vm._v("A whisper of sunshine spilled across the floor,")]), _vm._v(" "), _c('p', [_vm._v("The promise of pleasure we’d share forevermore.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd6db54c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0005.vue
// module id = 90
// module chunks = 0